<template>
    <div class="modal fade" id="viewPrintNoc">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <button @click="printNoc()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
              
            </div>
            <div class="modal-body" id="printNoc">
              <!-- right column -->
              <div class="row">
                
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile" v-if="seeRecord.member">
                      <table class="table printing" v-if="myhost !== 'fincare.13squad.com'">
                        <thead>
                          <td width="18%"><img :src="logo" height="90"></td>
                          <td class="text-right"><h4><strong>{{getCompanyRecord.companyName}}</strong> <br> <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                            <br><span v-if="getCompanyRecord.cin">CIN : {{getCompanyRecord.cin}},</span> <span v-if="getCompanyRecord.url">Website - {{getCompanyRecord.url}},</span> Mobile No - {{getCompanyRecord.phone}}, Email ID - {{getCompanyRecord.email}}
                            </small><br><br></h4>
                         </td>
                        </thead>
                      </table>
                      <hr style="border: 4px solid gray;">
                      <p class="text-center"><strong>(Incorporated under the Companies Act, 2013) Registered by Ministry of Corporate Affairs, Govt. of India</strong></p>
                      <!-- <h3 class="text-center"><strong>No Objection Certificate</strong></h3> -->
                      <div>
                        <p class="text-right">Date: {{curDate | myDate}}</p>
                        <p><strong>Loan Application No :</strong> {{seeRecord.applicationNo}}</p>
                        <p v-if="seeRecord.disbursement"><strong>Loan Amount :</strong> {{ getPlanAmt(seeRecord.disbursement) }}</p>
                        <p><strong>Customer Name : </strong><strong v-if="seeRecord.member">{{seeRecord.member.name}} ({{seeRecord.member.code}})</strong></p>
                        <p><strong>Mobile : </strong> <strong v-if="seeRecord.member">{{seeRecord.member.mobile}}</strong></p>
                        <p v-if="seeRecord.disbursement"><strong>Loan Disbursement Date :</strong> {{seeRecord.disbursement.disbursementDate}}</p>
                        
                        <h3 class="text-center">Subject - Non Objection Certificate (NOC)</h3>
                        <strong>Dear Customer</strong>
                        <p>With reference to above mentioned Subject we hereby issue the “LOAN CLOSURE LETTER” of Your Loan Account No <strong>{{seeRecord.applicationNo}}</strong> With The Name <strong v-if="seeRecord.member">{{seeRecord.member.name}}</strong> has fulfilled your entire obligation and paid all the outstanding dues under the said Loan Agreement.</p>
                        <br><br>
                        <p>This is for your information and needful.
                            <br>Your faithfully
                        </p><br>
                        <p>Chief Operating Manager</p><br>
                        <strong>Disclaimer:</strong>
                        <p>The NOC letter Will not be applicable in case this loan gets closed due to technical error or if the same is unpaid</p>
                        <br><br>
                        <p class="text-center">This is system generated letter and does not require any signature.</p>
                      </div><br>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
    
</template>
<script>
import { Printd } from 'printd'
import VueBarcode from 'vue-barcode'
import GetPlanAmount from '../../mixins/GetPlanAmount'
export default {
  name: 'PropsTesting',
  mixins: [GetPlanAmount],
  data () {
    return {
      curDate: new Date().toISOString().slice(0, 10),
      myhost: location.host,
      cssText: `.printing {
        font-family: sans-serif;
        text-align: center;
        padding-bottom: 2rem;

        print-color-adjust: exact;
        -webkit-print-color-adjust: exact;
      }
      p {
        text-align: justify;
      }
      h3 {
        text-align: center;
      }
      @page {
        size: A4;
        margin: 2;
      }
      table.center {
        margin-left: auto; 
        margin-right: auto;
      }
      table, th, td { padding:0.5em; border-collapse: collapse; }`
    }
  },
  methods: {
    // planAmt (disbursement) {
    //   var pln = JSON.parse(disbursement.plan)
    //   if (disbursement.loanAmount) {
    //     this.seeRecord.loanAmount = disbursement.loanAmount
    //     this.seeRecord.fileCharge = disbursement.fileCharge
    //     this.seeRecord.processingFee = disbursement.processingFee
    //   }
    //   if (pln.planType === 'normalReduced' || pln.planType === 'special') {
    //     return this.showPlanAmtReduced(pln)
    //   } else {
    //     return this.showPlanAmtNormal(pln)
    //   }
    // },
    // showPlanAmtNormal (pl) {
    //   if (this.seeRecord.loanAmount) {
    //     return this.seeRecord.loanAmount
    //   } else {
    //     return pl.amount
    //   }
    // },
    // showPlanAmtReduced (pl) {
    //   if (this.seeRecord.loanAmount) {
    //     return this.seeRecord.loanAmount + this.seeRecord.fileCharge + this.seeRecord.processingFee
    //   } else {
    //     if (pl.fileChargeIncludeAmt === 'false' && pl.processingFeeIncludeAmt === 'false') {
    //       return parseInt(pl.amount)
    //     } else if (pl.fileChargeIncludeAmt === 'false' && pl.processingFeeIncludeAmt === 'true') {
    //       return parseInt(pl.amount) + parseInt(pl.processingFee)
    //     } else if (pl.fileChargeIncludeAmt === 'true' && pl.processingFeeIncludeAmt === 'false') {
    //       return parseInt(pl.amount) + parseInt(pl.fileCharge)
    //     } else {
    //       return parseInt(pl.amount) + parseInt(pl.fileCharge) + parseInt(pl.processingFee)
    //     }
    //   }
    // },
    printNoc () {
      const d = new Printd()
      d.print(document.getElementById('printNoc'), [this.cssText])
    }
  },
  components: {
    'barcode': VueBarcode
  },
  props: {
    seeRecord: {},
    memberDetail: {},
    mem: {},
    pl: {},
    logo: '',
    getCompanyRecord: {}
  }
}
</script>



// WEBPACK FOOTER //
// Noc.vue?b89cff40